import { colorHighlight, sansSerif } from 'styles/css-constants';
import css from 'styled-jsx/css';

export const baseStyles = css`
  .RecipeRating__anchor {
    position: relative;
  }

  .RecipeRating__cancel,
  .RecipeRating__rate {
    border-color: ${colorHighlight};
  }

  .RecipeRating__cancel {
    background-color: transparent;
    color: ${colorHighlight};
  }

  .RecipeRating__text {
    margin-right: 0.5rem;
    font-size: 1em;
    font-family: ${sansSerif};
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }

  .RecipeRating__popup .RecipeRating__buttons {
    display: flex;
    justify-content: center;
  }

  .RecipeRating__popup .RecipeRating__buttons button {
    flex: 1 1 0;
    white-space: nowrap;
  }

  .RecipeRating__popup .RecipeRating__buttons button:last-child {
    margin-left: 1rem;
  }

  .RecipeRating__popup .RecipeRating__buttons button:disabled {
    /* CLEANUP: better disabled style */
    opacity: 0.5;
  }

  .RecipeRating__popup p {
    margin: 0 0 0.5rem;
    font-family: ${sansSerif};
    font-size: var(--fontScaleNeg2);
    font-weight: bold;
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }

  .RecipeRating__popup .RecipeRating__stars {
    margin-bottom: 1rem;
    font-size: 1.25rem;
    justify-content: flex-start;
  }

  .RecipeRating__rate {
    background-color: ${colorHighlight};
    color: #fff;
  }

  .RecipeRating__rating {
    display: flex;
    align-items: center;
  }

  .RecipeRating__stars {
    display: flex;
    align-items: center;
    list-style: none;
  }

  .RecipeRating .Tooltip {
    top: 1rem;
  }
`;

export const starStyles = css`
  .RecipeRating__star {
    width: 1.5em;
    height: 1.25em;
    padding-right: 0.25rem;
  }

  .RecipeRating__star-icon {
    width: 100%;
    height: 100%;
    background-color: transparent;
    border: none;
    outline: none;
    box-shadow: none;
  }

  .RecipeRating__star--1 {
    order: 1;
  }

  .RecipeRating__star--2 {
    order: 2;
  }

  .RecipeRating__star--3 {
    order: 3;
  }

  .RecipeRating__star--4 {
    order: 4;
  }

  .RecipeRating__star--5 {
    order: 5;
  }
`;
